import { render, staticRenderFns } from "./SplaServicePricing.vue?vue&type=template&id=4046b77b&scoped=true&"
import script from "./SplaServicePricing.vue?vue&type=script&lang=js&"
export * from "./SplaServicePricing.vue?vue&type=script&lang=js&"
import style0 from "./SplaServicePricing.vue?vue&type=style&index=0&id=4046b77b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4046b77b",
  null
  
)

export default component.exports